module.exports = __webpack_public_path__ + "static/PW-b860bc50e20fcb47aa40a193e39c0088.jpg";